// extracted by mini-css-extract-plugin
export var dividerContainer = "_9k-0";
export var line = "_9k-1";